var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m31 12 3 3-16 16-3-3-1 1 3 3-5 2 2-5 1-1zM36 36v-2H17l-5 2z"
  })));
};
export { SvgEdit as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMxIDEyTDM0IDE1TDE4IDMxTDE1IDI4TDE0IDI5TDE3IDMyTDEyIDM0TDE0IDI5TDE1IDI4TDMxIDEyWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTM2IDM2VjM0SDE3TDEyIDM2SDM2WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";